import { gql } from "@apollo/client";

export const GET_STAFF_ORGANIZATIONS = gql`
    query Organizations($profileId: Int!) {
        organizations(profileId: $profileId, page: 1, pageSize: 1000) {
            objects {
                id
                name
                slug
            }
        }
    }
`;

